import { Component, OnInit, Inject } from '@angular/core';
import { ProductService } from '../services/product.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Product } from '../system-data/system-data.component';



@Component({
  selector: 'app-product-insert',
  templateUrl: './product-insert.component.html',
  styleUrls: ['./product-insert.component.css']
})



export class ProductInsertComponent implements OnInit {

  id:number;
  parent_id:number;
  name:string;
  constructor(private productService:ProductService,public dialogRef: MatDialogRef<ProductInsertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Product) { 
    this.name = productService.getname();
    this.id = productService.getid();
    this.parent_id = productService.getparent_id();
  }

  ngOnInit() {
  }


  closeModal() {
    this.dialogRef.close();

  }


}
